import React from "react";
import docStyles from "../../css/Docs/Docs.module.css";

const DocWrapper = ({ children }) => {
  return <div className={docStyles.docWrapper}>{children}</div>;
};

export default DocWrapper;
